import * as React from 'react';

import TeksPage from '../../../../containers/teks/TeksPage';
import AssignmentFlowNavigation from '../../assignment_flow_navigation';

const AssignTeks = (props) => {
  return (
    <div>
      <AssignmentFlowNavigation />
      <TeksPage {...props} />
    </div>
  )
}

export default AssignTeks
